/**
 * PolicedStreams entity class
 */

/**
 * PolicedStreamsFactory
 * returns PolicedStreams entity class
 *
 * @class PolicedStreamsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.PolicedStreams} class
 *
 * @ngdoc factory
 * @name mwApp.factory:PolicedStreamsFactory
 */
/* @ngInject */
export default function PolicedStreamsFactory (Entity) {
  /* === PolicedStreams class === */

  /**
   * PolicedStreams model
   *
   * @class PolicedStreams
   * @classdesc PolicedStreams model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing PolicedStreams entity fields
   * @return {models.PolicedStreams} PolicedStreams entity
   */
  function PolicedStreams () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  PolicedStreams.prototype = Object.create(Entity.prototype)
  PolicedStreams.prototype.constructor = PolicedStreams

  /* === PolicedStreams instance methods & fields === */

  Object.assign(PolicedStreams.prototype, {

    /**
     * instance fields
     *
     * @memberof models.PolicedStreams#
     * @type {Object}
     */

    /**
     * iterated dynamic object
     * example
     * {
     *   [name: urlPolicy.id]:{ then:{ defaultStream } }
     * }
     */
    _fields: null

  })

  /* === PolicedStreams static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(PolicedStreams, Entity)
  PolicedStreams._name = 'PolicedStreams'
  PolicedStreams.init()

  return PolicedStreams
}
